import React, { useEffect, useState } from "react";
import ApiServices from "../../services/apiServices";
import "./index.css";
import storage from "../../services/storage";
import { toast } from "react-toastify";
import { useLoad } from "../../context/Load";
import ForcaSenha from "../../Components/ForcaSenha";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router";
import Tabela from "../../Components/Tabela";
import { FaRegEdit } from "react-icons/fa";
import Mask from "../../services/mask";
import { MdFileDownload } from "react-icons/md";

export default function ConfigAcoes() {
  const [listaParticipantes, setListaParticipantes] = useState([]);
  const [filtroColuna, setFiltroColuna] = useState([]);
  // const [novoFiltroColuna, setNovoFiltroColuna] = useState([]);
  const [pesquisar, setPesquisar] = useState("");
  const navigate = useNavigate();
  const { load, setLoad } = useLoad();
  const [paginacao, setPaginacao] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const colunas = [
    {
      accessorKey: "nome",
      header: "Nome",
      muiTableHeadCellProps: {
        align: "left",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
    },

    {
      accessorKey: "dataInicio",
      header: "De",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "dataFim",
      header: "Até",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "tipoAcao",
      header: "Tipo de Ação",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "status",
      header: "Status",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      header: "Ações",
      id: "mrt-custom-actions",
      size: 90,
      accessor: (row) => row, // Pode ser ajustado conforme necessário
      Cell: ({ row }) => (
        <div className="d-flex justify-content-end">
        <div
          className="pointer"
          onClick={() => {
            navigate(
              "/feedhyundai/configuracao-acoes/editar/" + row.original.acaoId
            );
          }}
          >
          <FaRegEdit style={{ fontSize: 20 }} />
        </div>
        <div
          className="pointer"
          onClick={() => {
            fnExtrairAcoes(row.original.acaoId)
          }}
          >
          <MdFileDownload style={{ fontSize: 20 }} />
        </div>
          </div>
      ),
      muiTableHeadCellProps: { align: "right" },
      muiTableBodyCellProps: { align: "right" },
    },
  ];

  async function fnExtrairAcoes(acaoId) {
    try {
      setLoad(true);
      let response = await ApiServices.apiDownloadXlsxGET(
        `relatorios/acao?${acaoId}`,
        "cadastroparticipantes"
      );
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnAcoes() {
    const parametros = {
      q: pesquisar || "",
    };

    try {
      setLoad(true);
      const queryString = new URLSearchParams(parametros).toString();
      let response = await ApiServices.apiGet(`participante?${queryString}`);

      if (response.statusCode == 200) {
        response.data.forEach((e) => {
          e.userName = Mask.cpf(e.userName);
          e.phoneNumber = Mask.cel(e.phoneNumber);
        });
        setListaParticipantes(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  
  useEffect(() => {
    fnAcoes();
  }, [pesquisar]);

  return (
    <>
      <div className="row">
        <span className="tituloPagina">CONFIGURAÇÃO DE AÇÕES</span>

        <div className="col-md-3">
          <button
            className="btn btn-primary my-2"
            onClick={() => {
              navigate("/feedhyundai/configuracao-acoes/novo");
            }}
          >
            + | Nova Ação
          </button>
        </div>
        <div className="subTituloPagina">Ações Cadastradas</div>
      </div>
      
      <Tabela
          buscaGlobal={true}
          setPesquisar={setPesquisar}
          buscaColunas={false}
          colunas={colunas}
          dados={listaParticipantes}
          setPaginacao={setPaginacao}
          paginacao={paginacao}
          filtroColuna={filtroColuna}
          setFiltroColuna={setFiltroColuna}
        />
    </>
  );
}
